import { render, staticRenderFns } from "./CommonAdd.vue?vue&type=template&id=348b94ec&"
import script from "./CommonAdd.vue?vue&type=script&lang=js&"
export * from "./CommonAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports